// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'split';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 11.66C9 8.443 6.083 2.885 1 .75m8 10.91c0-3.216 2.917-8.774 8-10.91M9 11.66v5.09' />
    <path d='M1 6.568V.75h5.818M17 6.568V.75h-5.818' />
  </g>
);

export const viewBox = '0 0 18 18';
